import { ReactNode } from 'react';
import { WarningBanner } from '../../Atoms/WarningBanner';
import { Run, RunStatus } from '../../../store/Run';

interface ProcessingRunBannerProps {
  run: Pick<Run, 'status'> | null;
  children?: ReactNode;
  className?: string;
}

export const ProcessingRunBanner = ({ run, children, className }: ProcessingRunBannerProps) => {
  if (run?.status !== RunStatus.PROCESSING) return null;

  return (
    <WarningBanner
      className={className}
      dataTestId="processing-run-banner">
      <strong>Processing run — not a published state.</strong> Values are still calculating and can change.
      {children && <> {children}</>}
    </WarningBanner>
  );
};
